<template lang="html">
  <v-container fluid class="mt-4">
    <base-items class="d-none" store-module="categories" @items="categories = $event" @state="categoriesState = $event" />
    <base-items class="d-none" store-module="itemgroups" @items="itemGroups = $event" @state="itemGroupsState = $event" />
    <base-items class="d-none" store-module="sideorders" @items="sideOrders = $event" @state="sideOrdersState = $event" />

    <v-row align="center">
      <v-col cols="auto" class="headline">Products</v-col>
      <v-col>
        <v-btn color="primary" fab depressed small @click="openProductForm(createNewProduct())" :disabled="(!itemGroups || itemGroups.length == 0) && !itemGroupsState.working"><v-icon>mdi-plus</v-icon></v-btn>
      </v-col>
    </v-row>
    <div v-if="(!itemGroups || itemGroups.length == 0) && !itemGroupsState.working" class="body-1 mt-1 mb-4 ">
      <v-alert
        outlined
        type="info"
        color="secondary darken-1"
        border="left"
        width="auto"
      >
      <span>Create at least one item group before you create a product.</span><br />
      <span>You find item groups in the menu on the left.</span>
      </v-alert>
    </div>
    <draggable v-model="products" class="row" ghost-class="operator__product-ghost">
      <v-col cols="auto" v-for="product in products" :key="product.id">
        <v-card width="250px" class="operator__product" :class="{'operator__product-hidden': product.hidden || product.unlisted}">
          <div class="operator__product-hidden-stack">
            <v-img
              v-if="itemsLayout.images"
              :src="productImageUrl(product)"
              width="250px"
              height="250px"
              contain
              :class="{'grey darken-3': $vuetify.theme.dark, 'grey lighten-3': !$vuetify.theme.dark}"
            ></v-img>
            <div v-else-if="product.hidden" class="py-7">

            </div>

            <div class="operator__product-hidden-icon" x-large>
              <span v-if="product.hidden">
                <v-icon>mdi-eye-off</v-icon>Hidden
              </span>
              <span v-if="product.unlisted">
                <span v-if="product.hidden"><br /></span>
                <v-icon>mdi-sort-variant-remove</v-icon>Unlisted
              </span>
            </div>

          </div>
          <v-card-text class="flex-column align-start">
            <div class="title text--primary">{{product.name}}</div>
            <div class="operator__product-description subtitle-1 text--primary">{{product.description}}</div>
            <div class="subtitle-2 mt-2 mb-2">{{product.price}}:-</div>
            <div v-if="product.itemgroupText" class="subtitle-2">{{product.itemgroupText}}</div>
            <div v-else class="subtitle-2 warning--text">MISSING ITEM GROUP</div>
            <div v-if="operator.product_categories" class="mt-2">
              <div v-if="product.categoryText" class="subtitle-2">{{product.categoryText}}</div>
              <div v-else class="subtitle-2 warning--text">MISSING CATEGORY</div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click.stop="openProductForm(product)">Edit</v-btn>
            <v-btn color="primary" text :loading="isRemovingProduct(product.id)" @click="deleteProduct(product)">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </draggable>

    <v-dialog :value="!!editingProduct" @input="closeProductForm()" max-width="600px" persistent scrollable>
      <product-form
        ref="productForm"
        :operator="operator"
        :product="editingProduct"
        :item-groups="itemGroups"
        :side-orders="sortedSideOrders"
        :categories="sortedCategories"
        @submit="saveProduct"
        @cancel="closeProductForm"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable';
import {BaseItems} from 'dync-baseitem';
import ProductForm from '../components/ProductForm.vue';
import {getItemById} from '@dynapp/wc-api-generic';
import itemsLayouts from './itemsLayouts';

export default {
  props: ['operator'],
  data () {
    return {
      editingProduct: null,
      isRemovingProductId: null,
      itemGroups: [],
      itemGroupsState: {},
      sideOrders: [],
      sideOrdersState: {},
      categories: [],
      categoriesState: {}
    }
  },
  computed: {
    itemsLayout() {
      var layout = getItemById(itemsLayouts, this.operator.layout_items, 'value');
      if (layout == null) {
        layout = getItemById(itemsLayouts, '2-grid', 'value');
      }
      return layout || {};
    },
    sortedSideOrders () {
      return this.sideOrders.slice(0).sort((a, b) => {
        if (a.name > b.name) {
          return 1;
        } else if (a.name < b.name) {
          return -1;
        } else {
          return 0;
        }
      });
    },
    sortedCategories () {
      var items = this.categories.slice(0);
      items.sort((a, b) => (a.order || 0) - (b.order || 0));
      return items;
    },
    products: {
      get () {
        const products = this.$store.getters['products/filterItems'](p => p.operator_id === this.operator.id);
        products.sort((p1, p2) => p1.order - p2.order);
        products.map((p) => {
          // Get info about item group
          var itemGroup = getItemById(this.itemGroups, p.itemgroup);
          if (itemGroup) {
            p.itemgroupText = itemGroup.name + '  (Vat ' + itemGroup.vat + '%)';
          }
          // Get info about category
          var category = getItemById(this.categories, p.category);
          if (category) {
            p.categoryText = category.title;
          }
        });
        return products;
      },
      set (products) {
        const reorderedProducts = products.map((p, i) => Object.assign({}, p, {order: i}));
        const reorderedProductsPayload = reorderedProducts.map(p => ({id: p.id, order: p.order}));

        this.$store.commit('startLoading', 'global');
        this.$store.commit('products/replaceItems', reorderedProducts);
        this.$store.dispatch('products/updateItems', reorderedProductsPayload).then(() => {
          this.$store.commit('endLoading', 'global');
        }).catch(() => {
          this.$store.commit('products/replaceItems', products);
          this.$snackbar({message: 'An error happened while saving product order.', theme: 'error'});
        });
      }
    }
  },
  methods: {
    isRemovingProduct (productId) {
      return this.isRemovingProductId === productId;
    },
    getNextOrderNumber() {
      var lastProduct = this.products[this.products.length-1];
      if (lastProduct && lastProduct.order != undefined) {
        return lastProduct.order + 1;
      } else {
        return 1;
      }
    },
    createNewProduct () {
      return {
        name: null,
        description: null,
        price: null,
        operator_id: this.operator.id,
        order: this.getNextOrderNumber()
      };
    },
    openProductForm (product) {
      var _product = Object.assign({}, product);
      delete _product.itemgroupText;
      delete _product.categoryText;
      this.editingProduct = _product;
    },
    closeProductForm () {
      this.editingProduct = null;
      this.$refs.productForm.reset();
    },
    saveProduct (product) {
      var result;

      if (product.id)
        result = this.$store.dispatch('products/updateItem', product);
      else
        result = this.$store.dispatch('products/createItem', product);

      result.then(() => {
        this.closeProductForm();
        this.$snackbar({message: 'Product saved', theme: 'success'});
      }, () => {
        this.$snackbar({message: 'Could not save product', theme: 'error'});
      });
    },
    deleteProduct (product) {
      // Should we only call "then" if result is ok?
      this.$confirm({
        title: `Are you sure you want to delete product "${product.name}"?`,
        message: 'You cannot undo this action'
      }).then(() => {
        this.isRemovingProductId = product.id;
        this.$store.dispatch('products/deleteItem', product.id).then(() => {
          this.isRemovingProductId = null;
          this.$snackbar({message: 'Product deleted', theme: 'success'});
        });
      });
    },
    productImageUrl (product) {
      return this.$store.getters['products/getAttachmentUrl'](product.id, 'dync-appshop-product-image.jpg');
    }
  },
  components: {
    ProductForm,
    BaseItems,
    draggable
  }
}
</script>

<style lang="scss" scoped>
  .operator__product-ghost .operator__product {
    background-color: var(--v-secondary-base)!important;
  }

  .operator__product {
    overflow: hidden;
  }

  .operator__product-hidden .operator__product-hidden-stack {
    position: relative;
  }
  .operator__product-hidden .operator__product-hidden-stack::after {
    content: ".";
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    position: absolute;
    top: 0;
    color: transparent;
    border-radius: inherit;
  }
  .operator__product-hidden-icon {
    display: none;
  }
  .operator__product-hidden .operator__product-hidden-icon {
    display: block;
    position: absolute;
    top: 16px;
    left: 16px;
    color: white;
    z-index: 1;
  }
  .operator__product-hidden .operator__product-hidden-icon i {
    color: inherit;
    margin-right: 8px;
  }
  .operator__product-hidden .operator__product-hidden-icon span {
    color: inherit;
    vertical-align: middle;
    text-transform: uppercase;
  }

  .operator__product-description {
    white-space: pre-wrap;
    max-height: 5.25rem;
    overflow: hidden;
  }
</style>
